export enum ContextVariableInstanceTypes {
  ContextVariable = 'ContextVariable',
  ListContextVariable = 'ListContextVariable',
  SystemContextVariable = 'SystemContextVariable',
  DatasetContextVariable = 'DatasetContextVariable',
}
